<script>
    import { darkMode } from "../../stores.js";

    export let showLabel = true;

    async function selectTheme(themeName) {
        await darkMode.setTheme(themeName);
        // Remove focus to close dropdown
        if (document.activeElement) {
            document.activeElement.blur();
        }
    }
</script>

<div class="theme-selector-container">
    {#if showLabel}
        <span class="label">Thème</span>
    {/if}

    <div class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm btn-outline">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-4 h-4"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"
                />
            </svg>
            <span class="hidden sm:inline ml-1">
                {darkMode.availableThemes.find(t => t.id === $darkMode)?.label || 'Thème'}
            </span>
        </div>

        <ul
            tabindex="0"
            class="dropdown-content menu z-[1] p-2 shadow-2xl bg-base-100 rounded-box w-64 mt-2"
        >
            {#each darkMode.availableThemes as theme}
                <li>
                    <button
                        type="button"
                        class="theme-item"
                        class:active={$darkMode === theme.id}
                        on:click={() => selectTheme(theme.id)}
                    >
                        <div data-theme={theme.id} class="theme-preview">
                            <div class="grid grid-cols-5 grid-rows-3">
                                <div class="bg-base-200 col-start-1 row-span-2 row-start-1"></div>
                                <div class="bg-base-300 col-start-1 row-start-3"></div>
                                <div class="bg-base-100 col-span-4 col-start-2 row-span-3 row-start-1 flex flex-col gap-1 p-2">
                                    <div class="font-bold text-sm">{theme.label}</div>
                                    <div class="flex flex-wrap gap-1">
                                        <div class="bg-primary flex aspect-square w-4 items-center justify-center rounded">
                                            <div class="text-primary-content text-xs font-bold">A</div>
                                        </div>
                                        <div class="bg-secondary flex aspect-square w-4 items-center justify-center rounded">
                                            <div class="text-secondary-content text-xs font-bold">A</div>
                                        </div>
                                        <div class="bg-accent flex aspect-square w-4 items-center justify-center rounded">
                                            <div class="text-accent-content text-xs font-bold">A</div>
                                        </div>
                                        <div class="bg-neutral flex aspect-square w-4 items-center justify-center rounded">
                                            <div class="text-neutral-content text-xs font-bold">A</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {#if $darkMode === theme.id}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 text-success"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        {/if}
                    </button>
                </li>
            {/each}
        </ul>
    </div>
</div>

<style>
    .theme-selector-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 0.5rem;
    }

    .label {
        font-weight: 500;
        font-size: 0.9rem;
    }

    .theme-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
        padding: 0.5rem;
        cursor: pointer;
        border-radius: 0.5rem;
        transition: background-color 0.2s;
        border: none;
        background: transparent;
    }

    .theme-item:hover {
        background-color: hsl(var(--b2));
    }

    .theme-item.active {
        background-color: hsl(var(--b2));
    }

    .theme-preview {
        flex: 1;
        border-radius: 0.375rem;
        overflow: hidden;
        border: 1px solid hsl(var(--bc) / 0.1);
    }

    .theme-preview > div {
        height: 60px;
    }
</style>
